// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { ArrowRight, SlidersHorizontal } from "lucide-react";
// import "../css/Desktop.css";
// import Topbar from "./Topbar";
// import { useNavigate } from "react-router-dom";
// import backIMG from "../assets/img/bg_dekstop.png";
// import RedFlag from "../assets/img/RedFlag.png";
// import GreenFlag from "../assets/img/GreenFlag.png";

// export default function AIThinkStorePage({ activeTab, selectedFilter }) {
//   const navigate = useNavigate();
//   const [useCases, setUseCases] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [showModal, setShowModal] = useState(false);
//   const [selectedProduct, setSelectedProduct] = useState(null);

//   const token =
//     localStorage.getItem("token") || sessionStorage.getItem("token");

//   const fetchUseCases = async () => {
//     setLoading(true);
//     try {
//       const response = await axios.get(
//         `${process.env.REACT_APP_API_URL}/products`,
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );
//       setUseCases(response.data);
//     } catch (error) {
//       console.error("Error fetching use cases:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchUseCases();
//   }, []);

//   const filteredUseCases = useCases
//     .filter((item) => {
//       if (item.product_status !== "1") return false; // active only
//       if (activeTab !== "All" && item.product_type !== activeTab) return false;
//       if (selectedFilter && item.product_industry !== selectedFilter)
//         return false;
//       return true;
//     })
//     .sort((a, b) => {
//       // Green flag first, red flag later
//       const aFlag = a.product_route ? 1 : 0; // 1 = green
//       const bFlag = b.product_route ? 1 : 0;
//       return bFlag - aFlag; // sort descending, so green (1) comes before red (0)
//     });

//   const handleProductClick = (useCase) => {
//     const route = useCase.product_route?.replace(/\\/g, "/");
//     if (!route) {
//       setSelectedProduct(useCase);
//       setShowModal(true);
//       return;
//     }
//     if (route.startsWith("http://") || route.startsWith("https://")) {
//       window.open(route, "_blank", "noopener,noreferrer");
//     } else {
//       navigate(route);
//     }
//   };

//   return (
//     <div className="relative">
//       {/* Background image */}
//       <div
//         className="fixed inset-0 bg-cover bg-center z-0"
//         style={{
//           backgroundImage: `url(${backIMG})`,
//         }}
//       >
//         <div className="absolute inset-0 bg-black opacity-70 backdrop-blur-lg z-0"></div>
//       </div>

//       {/* Main grid content */}
//       <div className="relative z-0 p-4 md:p-8 lg:p-12 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4">
//         {filteredUseCases.map((useCase, index) => (
//           <div
//             key={index}
//             className="bgwhite rounded-xl shadow overflow-hidden flex flex-col cursor-pointer transform transition-transform duration-300 hover:scale-105 hover:shadow-lg"
//             onClick={() => handleProductClick(useCase)}
//           >
//             <div className="relative">
//               <img
//                 src={`${
//                   process.env.REACT_APP_SERVER_URL
//                 }/${useCase.product_image?.replace(/\\/g, "/")}`}
//                 alt={useCase.product_name}
//                 className="w-full h-40 object-cover"
//               />
//               <img
//                 src={useCase.product_route ? GreenFlag : RedFlag}
//                 alt={useCase.product_route ? "Green Flag" : "Red Flag"}
//                 className="absolute top-2 right-2 w-6 h-6 md:w-8 md:h-8"
//               />
//             </div>

//             <div className="p-3 justify-between flex-1 relative">
//               <h3
//                 className="font-bold text-[18px] whitespace-nowrap textprimary truncate capitalize"
//                 title={useCase.product_name}
//               >
//                 {useCase.product_name}
//               </h3>
//               <div className="justify-between items-center mt-2 textblack">
//                 <p className="text-sm capitalize">
//                   <span className="font-bold">Sector: </span>
//                   {useCase.product_industry}
//                 </p>
//                 <p className="text-sm capitalize three-line-truncate">
//                   <span className="font-bold">Description: </span>
//                   {useCase.product_description}
//                 </p>
//               </div>
//               <ArrowRight
//                 className="textprimary absolute right-4 bottom-4"
//                 size={16}
//               />
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* Restricted Access Modal */}
//       {showModal && selectedProduct && (
//         <div
//           className="modal fade show d-block"
//           tabIndex="-1"
//           style={{
//             backgroundColor: "rgba(0, 0, 0, 0.75)",
//             backdropFilter: "blur(8px)",
//             animation: "fadeIn 0.3s ease-out",
//           }}
//         >
//           <div
//             className="modal-dialog modal-dialog-centered"
//             style={{
//               animation: "slideUp 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)",
//               maxWidth: "800px", // Reduced from modal-lg
//               width: "90%",
//             }}
//           >
//             <div
//               className="modal-content border-0 position-relative"
//               style={{
//                 borderRadius: "16px", // Reduced from 20px
//                 overflow: "hidden",
//                 boxShadow:
//                   "0 20px 40px rgba(0, 0, 0, 0.25), 0 0 0 1px rgba(255, 255, 255, 0.1)",
//                 background: "linear-gradient(145deg, #ffffff 0%, #f8f9ff 100%)",
//                 maxHeight: "85vh", // Limit height
//               }}
//             >
//               {/* Animated background pattern */}
//               <div
//                 style={{
//                   position: "absolute",
//                   top: 0,
//                   left: 0,
//                   right: 0,
//                   height: "80px", // Reduced from 120px
//                   background:
//                     "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//                   opacity: 0.1,
//                   zIndex: 1,
//                 }}
//               />

//               {/* Close button */}
//               <button
//                 type="button"
//                 className="position-absolute top-0 end-0 m-2" // Reduced margin
//                 aria-label="Close"
//                 onClick={() => setShowModal(false)}
//                 style={{
//                   zIndex: 15,
//                   background: "rgba(255, 255, 255, 0.9)",
//                   border: "none",
//                   borderRadius: "50%",
//                   width: "32px", // Reduced from 40px
//                   height: "32px",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   fontSize: "14px", // Reduced from 18px
//                   color: "#666",
//                   backdropFilter: "blur(10px)",
//                   transition: "all 0.3s ease",
//                   cursor: "pointer",
//                   boxShadow: "0 3px 10px rgba(0, 0, 0, 0.1)",
//                 }}
//                 onMouseEnter={(e) => {
//                   e.target.style.background = "rgba(220, 53, 69, 0.1)";
//                   e.target.style.color = "#dc3545";
//                   e.target.style.transform = "scale(1.1) rotate(90deg)";
//                 }}
//                 onMouseLeave={(e) => {
//                   e.target.style.background = "rgba(255, 255, 255, 0.9)";
//                   e.target.style.color = "#666";
//                   e.target.style.transform = "scale(1) rotate(0deg)";
//                 }}
//               >
//                 ✕
//               </button>

//               {/* Product image section - COMPACT */}
//               <div
//                 className="d-flex justify-content-center align-items-center position-relative"
//                 style={{
//                   width: "100%",
//                   height: "180px", // Significantly reduced from 320px
//                   background:
//                     "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
//                   overflow: "hidden",
//                   zIndex: 2,
//                 }}
//               >
//                 {/* Smaller decorative elements */}
//                 <div
//                   style={{
//                     position: "absolute",
//                     top: "15px",
//                     left: "15px",
//                     width: "30px", // Reduced from 60px
//                     height: "30px",
//                     borderRadius: "50%",
//                     background:
//                       "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//                     opacity: 0.1,
//                     animation: "float 3s ease-in-out infinite",
//                   }}
//                 />
//                 <div
//                   style={{
//                     position: "absolute",
//                     bottom: "15px",
//                     right: "15px",
//                     width: "20px", // Reduced from 40px
//                     height: "20px",
//                     borderRadius: "50%",
//                     background:
//                       "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
//                     opacity: 0.1,
//                     animation: "float 3s ease-in-out infinite 1.5s",
//                   }}
//                 />

//                 <div
//                   style={{
//                     position: "relative",
//                     padding: "12px", // Reduced from 20px
//                     borderRadius: "12px", // Reduced from 15px
//                     background: "rgba(255, 255, 255, 0.9)",
//                     backdropFilter: "blur(10px)",
//                     boxShadow: "0 6px 25px rgba(0, 0, 0, 0.1)",
//                     border: "1px solid rgba(255, 255, 255, 0.2)",
//                   }}
//                 >
//                   <img
//                     src={`${
//                       process.env.REACT_APP_SERVER_URL
//                     }/${selectedProduct.product_image?.replace(/\\/g, "/")}`}
//                     alt={selectedProduct.product_name}
//                     style={{
//                       maxWidth: "180px", // Significantly reduced from 1000px
//                       maxHeight: "180px",
//                       objectFit: "contain",
//                       borderRadius: "8px",
//                       transition: "transform 0.3s ease",
//                     }}
//                     onMouseEnter={(e) => {
//                       e.target.style.transform = "scale(1.05)";
//                     }}
//                     onMouseLeave={(e) => {
//                       e.target.style.transform = "scale(1)";
//                     }}
//                   />
//                 </div>
//               </div>

//               {/* Content section - COMPACT */}
//               <div
//                 className="p-3 text-center position-relative" // Reduced padding from p-5
//                 style={{ zIndex: 2 }}
//               >
//                 {/* Smaller warning icon */}
//                 <div
//                   style={{
//                     display: "inline-flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     width: "50px", // Reduced from 80px
//                     height: "50px",
//                     borderRadius: "50%",
//                     background:
//                       "linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%)",
//                     marginBottom: "12px", // Reduced from 20px
//                     boxShadow: "0 6px 15px rgba(238, 90, 36, 0.3)",
//                     animation: "pulse 2s infinite",
//                   }}
//                 >
//                   <i
//                     className="bi bi-shield-lock-fill"
//                     style={{
//                       fontSize: "20px", // Reduced from 32px
//                       color: "white",
//                     }}
//                   />
//                 </div>

//                 <h5 // Changed from h4 to h5
//                   className="fw-bold mb-3" // Reduced margin
//                   style={{
//                     background:
//                       "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//                     backgroundClip: "text",
//                     WebkitBackgroundClip: "text",
//                     WebkitTextFillColor: "transparent",
//                     fontSize: "1.1rem", // Reduced from 1.5rem
//                     letterSpacing: "-0.3px",
//                   }}
//                 >
//                   🔒 Restricted Access
//                 </h5>

//                 <div
//                   style={{
//                     background:
//                       "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
//                     borderRadius: "12px", // Reduced from 15px
//                     padding: "16px", // Reduced from 25px
//                     border: "1px solid rgba(108, 117, 125, 0.1)",
//                     position: "relative",
//                     overflow: "hidden",
//                   }}
//                 >
//                   <p
//                     className="mb-0 position-relative"
//                     style={{
//                       color: "#495057",
//                       lineHeight: "1.5", // Reduced from 1.7
//                       fontSize: "0.85rem", // Reduced from 1rem
//                       zIndex: 1,
//                     }}
//                   >
//                     This section contains sensitive information for authorized
//                     users only. Access is strictly regulated. Contact your
//                     administrator for approval.
//                   </p>
//                 </div>

//                 {/* Compact action buttons */}
//                 <div className="mt-3 d-flex gap-2 justify-content-center">
//                   {" "}
//                   {/* Reduced gap and margin */}
//                   <button
//                     className="btn btn-sm" // Added btn-sm
//                     onClick={() => setShowModal(false)}
//                     style={{
//                       background:
//                         "linear-gradient(135deg, #6c757d 0%, #495057 100%)",
//                       border: "none",
//                       borderRadius: "20px", // Reduced from 25px
//                       padding: "8px 100px", // Reduced from 10px 25px
//                       color: "white",
//                       fontWeight: "500",
//                       fontSize: "0.8rem",
//                       transition: "all 0.3s ease",
//                       boxShadow: "0 3px 10px rgba(108, 117, 125, 0.3)",
//                     }}
//                     onMouseEnter={(e) => {
//                       e.target.style.transform = "translateY(-1px)";
//                       e.target.style.boxShadow =
//                         "0 5px 15px rgba(108, 117, 125, 0.4)";
//                     }}
//                     onMouseLeave={(e) => {
//                       e.target.style.transform = "translateY(0)";
//                       e.target.style.boxShadow =
//                         "0 3px 10px rgba(108, 117, 125, 0.3)";
//                     }}
//                   >
//                     Ok
//                   </button>
//                   {/* <button
//                     className="btn btn-sm"
//                     style={{
//                       background:
//                         "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//                       border: "none",
//                       borderRadius: "20px",
//                       padding: "8px 16px",
//                       color: "white",
//                       fontWeight: "500",
//                       fontSize: "0.8rem",
//                       transition: "all 0.3s ease",
//                       boxShadow: "0 3px 10px rgba(102, 126, 234, 0.3)",
//                     }}
//                     onMouseEnter={(e) => {
//                       e.target.style.transform = "translateY(-1px)";
//                       e.target.style.boxShadow =
//                         "0 5px 15px rgba(102, 126, 234, 0.4)";
//                     }}
//                     onMouseLeave={(e) => {
//                       e.target.style.transform = "translateY(0)";
//                       e.target.style.boxShadow =
//                         "0 3px 10px rgba(102, 126, 234, 0.3)";
//                     }}
//                   >
//                     Contact Admin
//                   </button> */}
//                 </div>
//               </div>
//             </div>
//           </div>

//           <style jsx>{`
//             @keyframes fadeIn {
//               from {
//                 opacity: 0;
//               }
//               to {
//                 opacity: 1;
//               }
//             }

//             @keyframes slideUp {
//               from {
//                 opacity: 0;
//                 transform: translateY(30px) scale(0.95);
//               }
//               to {
//                 opacity: 1;
//                 transform: translateY(0) scale(1);
//               }
//             }

//             @keyframes float {
//               0%,
//               100% {
//                 transform: translateY(0px);
//               }
//               50% {
//                 transform: translateY(-6px);
//               }
//             }

//             @keyframes pulse {
//               0% {
//                 transform: scale(1);
//               }
//               50% {
//                 transform: scale(1.05);
//               }
//               100% {
//                 transform: scale(1);
//               }
//             }

//             .modal-content {
//               transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
//             }
//           `}</style>
//         </div>
//       )}
//     </div>
//   );
// }

import React, { useState, useEffect } from "react";
import axios from "axios";
import { ArrowRight } from "lucide-react";
import "../css/Desktop.css";
import { useNavigate } from "react-router-dom";
import backIMG from "../assets/img/bg_dekstop.png";
import RedFlag from "../assets/img/RedFlag.png";
import GreenFlag from "../assets/img/GreenFlag.png";

export default function AIThinkStorePage({ activeTab, selectedFilter }) {
  const navigate = useNavigate();
  const [useCases, setUseCases] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const token =
    localStorage.getItem("token") || sessionStorage.getItem("token");

  const fetchUseCases = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/products`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setUseCases(response.data);
    } catch (error) {
      console.error("Error fetching use cases:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUseCases();
  }, []);

  // Filter & sort: green flag first, red flag later
  const filteredUseCases = useCases
    .filter((item) => {
      if (item.product_status !== "1") return false;
      if (activeTab !== "All" && item.product_type !== activeTab) return false;
      if (selectedFilter && item.product_industry !== selectedFilter)
        return false;
      return true;
    })
    .sort((a, b) => {
      const aFlag = a.product_route ? 1 : 0;
      const bFlag = b.product_route ? 1 : 0;
      return bFlag - aFlag; // green flag first
    });

  const handleProductClick = (useCase) => {
    const route = useCase.product_route?.replace(/\\/g, "/");
    if (!route) {
      setSelectedProduct(useCase);
      setShowModal(true);
      return;
    }
    if (route.startsWith("http://") || route.startsWith("https://")) {
      window.open(route, "_blank", "noopener,noreferrer");
    } else {
      navigate(route);
    }
  };

  return (
    <div className="relative">
      {/* Background image */}
      <div
        className="fixed inset-0 bg-cover bg-center z-0"
        style={{
          backgroundImage: `url(${backIMG})`,
        }}
      >
        <div className="absolute inset-0 bg-black opacity-70 backdrop-blur-lg z-0"></div>
      </div>

      {/* Main grid content */}
      <div className="relative z-0 p-4 md:p-8 lg:p-12 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4">
        {filteredUseCases.map((useCase, index) => (
          <div
            key={index}
            className="bgwhite rounded-xl shadow overflow-hidden flex flex-col cursor-pointer transform transition-transform duration-300 hover:scale-105 hover:shadow-lg"
            onClick={() => handleProductClick(useCase)}
          >
            <div className="relative">
              <img
                src={`${
                  process.env.REACT_APP_SERVER_URL
                }/${useCase.product_image?.replace(/\\/g, "/")}`}
                alt={useCase.product_name}
                className="w-full h-40 object-cover"
              />
              <img
                src={useCase.product_route ? GreenFlag : RedFlag}
                alt={useCase.product_route ? "Green Flag" : "Red Flag"}
                className="absolute top-2 right-2 w-6 h-6 md:w-8 md:h-8"
              />
            </div>

            <div className="p-3 justify-between flex-1 relative">
              <h3
                className="font-bold text-[18px] whitespace-nowrap textprimary truncate capitalize"
                title={useCase.product_name}
              >
                {useCase.product_name}
              </h3>
              <div className="justify-between items-center mt-2 textblack">
                <p className="text-sm capitalize">
                  <span className="font-bold">Sector: </span>
                  {useCase.product_industry}
                </p>
                <p className="text-sm capitalize three-line-truncate">
                  <span className="font-bold">Description: </span>
                  {useCase.product_description}
                </p>
              </div>
              <ArrowRight
                className="textprimary absolute right-4 bottom-4"
                size={16}
              />
            </div>
          </div>
        ))}
      </div>

      {/* Restricted Access Modal */}
      {showModal && selectedProduct && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          style={{
            backgroundColor: "rgba(0, 0, 0, 0.75)",
            backdropFilter: "blur(8px)",
            animation: "fadeIn 0.3s ease-out",
          }}
        >
          <div
            className="modal-dialog modal-dialog-centered"
            style={{
              animation: "slideUp 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)",
              maxWidth: "1000px", // increased width
              width: "95%", // responsive
              maxHeight: "90vh", // increased height
            }}
          >
            <div
              className="modal-content border-0 position-relative"
              style={{
                borderRadius: "16px",
                overflow: "hidden",
                boxShadow:
                  "0 20px 40px rgba(0, 0, 0, 0.25), 0 0 0 1px rgba(255, 255, 255, 0.1)",
                background: "linear-gradient(145deg, #ffffff 0%, #f8f9ff 100%)",
                maxHeight: "100vh",
              }}
            >
              {/* Animated background pattern */}
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  height: "80px",
                  background:
                    "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                  opacity: 0.1,
                  zIndex: 1,
                }}
              />

              {/* Close button */}
              <button
                type="button"
                className="position-absolute top-0 end-0 m-2"
                aria-label="Close"
                onClick={() => setShowModal(false)}
                style={{
                  zIndex: 15,
                  background: "rgba(255, 255, 255, 0.9)",
                  border: "none",
                  borderRadius: "50%",
                  width: "32px",
                  height: "32px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "14px",
                  color: "#666",
                  backdropFilter: "blur(10px)",
                  transition: "all 0.3s ease",
                  cursor: "pointer",
                  boxShadow: "0 3px 10px rgba(0, 0, 0, 0.1)",
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = "rgba(220, 53, 69, 0.1)";
                  e.target.style.color = "#dc3545";
                  e.target.style.transform = "scale(1.1) rotate(90deg)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = "rgba(255, 255, 255, 0.9)";
                  e.target.style.color = "#666";
                  e.target.style.transform = "scale(1) rotate(0deg)";
                }}
              >
                ✕
              </button>

              {/* Product image section */}
              <div
                style={{
                  width: "100%",
                  height: "350px", // increased height
                  background:
                    "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
                  overflow: "hidden",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  zIndex: 2,
                }}
              >
                <img
                  src={`${
                    process.env.REACT_APP_SERVER_URL
                  }/${selectedProduct.product_image?.replace(/\\/g, "/")}`}
                  alt={selectedProduct.product_name}
                  style={{
                    width: "70%", // scales with modal
                    height: "auto",
                    maxHeight: "380px",
                    objectFit: "cover",
                    borderRadius: "8px",
                    transition: "transform 0.3s ease",
                    padding: '20px 0'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.transform = "scale(1.05)";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = "scale(1)";
                  }}
                />
              </div>

              {/* Content section */}
              <div
                className="p-3 text-center position-relative"
                style={{ zIndex: 2 }}
              >
                <div
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "50px",
                    height: "50px",
                    borderRadius: "50%",
                    background:
                      "linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%)",
                    marginBottom: "12px",
                    boxShadow: "0 6px 15px rgba(238, 90, 36, 0.3)",
                    animation: "pulse 2s infinite",
                  }}
                >
                  <i
                    className="bi bi-shield-lock-fill"
                    style={{ fontSize: "20px", color: "white" }}
                  />
                </div>

                <h5
                  className="fw-bold mb-3"
                  style={{
                    background:
                      "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                    backgroundClip: "text",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    fontSize: "1.1rem",
                    letterSpacing: "-0.3px",
                  }}
                >
                  🔒 Restricted Access
                </h5>

                <div
                  style={{
                    background:
                      "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
                    borderRadius: "12px",
                    padding: "16px",
                    border: "1px solid rgba(108, 117, 125, 0.1)",
                    position: "relative",
                    overflow: "hidden",
                  }}
                >
                  <p
                    className="mb-0 position-relative"
                    style={{
                      color: "#495057",
                      lineHeight: "1.5",
                      fontSize: "0.85rem",
                      zIndex: 1,
                    }}
                  >
                    This section contains sensitive information for authorized
                    users only. Access is strictly regulated. Contact your
                    administrator for approval.
                  </p>
                </div>

                <div className="mt-3 d-flex gap-2 justify-content-center">
                  <button
                    className="btn btn-sm"
                    onClick={() => setShowModal(false)}
                    style={{
                      background:
                        "linear-gradient(135deg, #6c757d 0%, #495057 100%)",
                      border: "none",
                      borderRadius: "20px",
                      padding: "8px 100px",
                      color: "white",
                      fontWeight: "500",
                      fontSize: "0.8rem",
                      transition: "all 0.3s ease",
                      boxShadow: "0 3px 10px rgba(108, 117, 125, 0.3)",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.transform = "translateY(-1px)";
                      e.target.style.boxShadow =
                        "0 5px 15px rgba(108, 117, 125, 0.4)";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.transform = "translateY(0)";
                      e.target.style.boxShadow =
                        "0 3px 10px rgba(108, 117, 125, 0.3)";
                    }}
                  >
                    Ok
                  </button>
                </div>
              </div>
            </div>
          </div>

          <style jsx>{`
            @keyframes fadeIn {
              from {
                opacity: 0;
              }
              to {
                opacity: 1;
              }
            }
            @keyframes slideUp {
              from {
                opacity: 0;
                transform: translateY(30px) scale(0.95);
              }
              to {
                opacity: 1;
                transform: translateY(0) scale(1);
              }
            }
            @keyframes pulse {
              0% {
                transform: scale(1);
              }
              50% {
                transform: scale(1.05);
              }
              100% {
                transform: scale(1);
              }
            }
            .modal-content {
              transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
            }
          `}</style>
        </div>
      )}
    </div>
  );
}
